import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Shown above the feed for logged-out visitors: a quick "what is this" nudge
// that decodes the Yes/No colors and links to the full What is Pinion? page.
export const IntroBand: React.FC = () => {
  const location = useLocation();

  return (
    <div className="text-white bg-app-card rounded-app-base p-app-lg mb-app-base border border-gray-800">
      <h2 className="text-app-xl font-bold">
        Welcome to <span className="text-app-primary">Pinion</span> 👋
      </h2>
      <p className="text-app-gray-light mt-app-xs leading-relaxed">
        Big questions, simple answers. Vote <span className="text-app-primary font-semibold">Yes</span> or
        <span className="text-app-secondary font-semibold"> No</span>, see how the crowd splits, and find your
        opinion soulmates.
      </p>

      <div className="flex items-center gap-app-lg mt-app-sm">
        <span className="flex items-center gap-app-xs">
          <span className="inline-block w-app-xl h-app-base-2 rounded-app-xs bg-app-primary" />
          <span className="text-app-primary text-app-base font-semibold">Yes</span>
        </span>
        <span className="flex items-center gap-app-xs">
          <span className="inline-block w-app-xl h-app-base-2 rounded-app-xs bg-app-secondary" />
          <span className="text-app-secondary text-app-base font-semibold">No</span>
        </span>
      </div>

      <div className="flex flex-wrap gap-app-base mt-app-base">
        <Link
          to="/register"
          state={{ backgroundLocation: location }}
          className="bg-app-primary text-black font-semibold px-app-lg py-app-s rounded-app-sm"
        >
          Sign up
        </Link>
        <Link
          to="/about"
          className="border border-app-gray text-white px-app-lg py-app-s rounded-app-sm hover:border-app-white"
        >
          What is Pinion? →
        </Link>
      </div>
    </div>
  );
};
